/**
 * Central export file for error boundary components
 *
 * Recommended: Use SilentErrorBoundary for most cases
 * - Doesn't break UI rendering
 * - Shows user notification
 * - Tracks errors to ClickHouse
 */

// Main recommended boundary - use this for most cases
export {
  SilentErrorBoundary,
  NonCriticalBoundary,
  ThirdPartyBoundary,
  AnalyticsBoundary,
  withSilentErrorBoundary,
} from './SilentErrorBoundary';

// Base boundary (used internally by specialized boundaries below)
export { BaseErrorBoundary } from './BaseErrorBoundary';
export type { BaseErrorBoundaryProps, ErrorBoundaryState } from './BaseErrorBoundary';

// Specialized boundaries for specific use cases
export { RowErrorBoundary } from './RowErrorBoundary';
export { AsyncErrorBoundary, AsyncBoundary, useAsyncError } from './AsyncErrorBoundary';
// NetworkErrorBoundary removed - use SilentErrorBoundary with showNotification instead
export { ProviderErrorBoundary, ProviderBoundary, withProviderErrorBoundary } from './ProviderErrorBoundary';

// Export utility functions
export {
  isNetworkError,
  isChunkLoadError,
  getErrorMessage,
  captureErrorBoundaryException,
  getErrorBoundaryNotificationMessage,
} from './errorUtils';

// Default export for convenience
export { SilentErrorBoundary as default } from './SilentErrorBoundary';